import React from 'react';
import { FeaturesSectionHoverEffectsAndroidApp } from '../common/feature-section-hover-effects-android-app';
const AndroidServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <p
                            className="text-primary mb-0 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            We Provide
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Android Application Development Services
                        </h2>
                    </div>
                </div>
                <div className="row relative">         
                    <div className="w-full">
                       <FeaturesSectionHoverEffectsAndroidApp />
                    </div>         
                </div>
            </div>
        </div>
    );
};

export default AndroidServies;
